export const STREAMED_QUERY_RETRY = { retry: 1, retryDelay: 500 };
